(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // ===== Parallax =====
    const blocks = document.querySelectorAll('.image-block--parallax');
    if (blocks.length) {
      let ticking = false;

      const updateParallax = () => {
        const vh = window.innerHeight || 1;

        blocks.forEach((block) => {
          const rect = block.getBoundingClientRect();
          const img = block.querySelector('.image-block__image');
          if (!img) return;

          const strength =
            parseFloat(getComputedStyle(block).getPropertyValue('--image-parallax-strength')) || 0.35;

          const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
          const offset = -progress * strength * vh;

          block.style.setProperty('--image-parallax-offset', `${offset}px`);
        });

        ticking = false;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateParallax);
      };

      updateParallax();
      document.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', updateParallax);
    }

    // ===== Text reveal ONLY inside this section (repeat on every enter/leave) =====
    const sectionRoot = document.querySelector('#shopify-section-template--27355183579477__section_hrAHcw');
    if (!sectionRoot) return;

    const textBlocks = sectionRoot.querySelectorAll('.image-block--has-overlay');
    if (!textBlocks.length) return;

    const reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      textBlocks.forEach((b) => b.classList.add('image-block--text-revealed'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // remove + re-add to restart animation even if it was already revealed
            entry.target.classList.remove('image-block--text-revealed');
            // force reflow
            void entry.target.offsetWidth;
            entry.target.classList.add('image-block--text-revealed');
          } else {
            // remove when leaving so it can animate again next time
            entry.target.classList.remove('image-block--text-revealed');
          }
        });
      },
      { root: null, threshold: 0.6 }
    );

    textBlocks.forEach((b) => io.observe(b));
  });
  } catch(e) { console.error(e); }
})();

})();
